import type { FaireProductEntity } from "../../entity_types/product";

export const p_76gscxkp: FaireProductEntity = {
  token: "p_76gscxkp",
  type: "product",
  name: "Signature Scent | White Soy Candle + Gift Box | 8oz.",
  brandToken: "b_64a9u4sm",
  brandName: "The Rustic House",
  imageUrl:
    "https://cdn.faire.com/fastly/20c40650df8cc97f0378be5dde616b497172c8d0ec65c361106122cddd73f23c.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/1c49e107e65d2ce748a39b5d57e8618aa5dfdae513cb4118930ec4d03dbaee36.png",
    "https://cdn.faire.com/fastly/a73e281096f1b8757a8d9b1a12b3824825b41bfb195d7bb6c9ed7ba90660058e.png",
  ],
  priceDollars: 15,
  description:
    "Exotic yet sensual, this subtle fragrance is our best-selling year-round scent. A sophisticated blend of amber, tobacco, and vanilla; additional scent notes of cocoa, lavender, and bergamot add complexity and depth, creating a luxurious and lavish feel to elevate any space.\n\nScent Notes: Amber + Tobacco + Vanilla\n\nSpecifications:\nMatte White Glass Candle | Glass + Wood Lid + Gift Box | Case Packs of 4 | Net Weight 8 oz. | 50 Hour Burn Time\n\nBenefits: \nSoy Candle | Vegan | 100% Cotton Wick | Phthalate Free | Paraben Free | Fragrance + Essential Oils | 100% Recyclable | Large Scent Throw | Zero Dyes or Additives | Burns even for the life of the candle\n\nFulfillment time is 5 to 10 business days prior to shipping. Rush orders are available for an additional fee ($1 per item). All orders ship via UPS from Chattanooga, TN. \n\n*In case you need to smell to believe - please check out our Sample options!",
  tags: [],
  msrpDollars: 30,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-08-15T03:47:44.774Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
